import styled from "styled-components";
import dottedImg from "assets/images/dottedBgHero.svg";

export const LoginContainer = styled.div`
  height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #ffffff;
  @media (max-width: 1024px) {
    background: none;
    padding: 0;
    flex-direction: column-reverse;
    align-items: center;
    /* height: auto; */
  }
`;
export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  margin: auto;
  @media (max-width: 1024px) {
    padding: 0;
    justify-content: center;
  }
`;

export const LogoContainer = styled.div`
  background: url(${dottedImg}) no-repeat top right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 62px;
  height: 65px;
  & > div {
    display: flex;
    align-items: center;
    margin-right: 290px;
  }
  h2 {
    font-size: 32px;
    color: ${(props) => props.color};
    font-weight: 700;
    margin-right: 10px;
  }
  @media (max-width: 1024px) {
    text-align: center;
    background: none;
    padding: 0;
    & > div {
      margin: auto auto;
    }
  }
`;
export const MainContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: max-content;
  margin: auto 0 auto 325px;
  @media (max-width: 1440px) {
    margin-left: 100px;
  }
  @media (max-width: 1200px) {
    margin-left: 10px;
  }
  @media (max-width: 1070px) {
    margin-left: 0px;
  }
  @media (max-width: 1024px) {
    padding: 0;
    width: 100%;
    form {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 100px;
    }
  }
`;

export const HeaderValidation = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  color: var(--text-500);
  margin-bottom: 45px;
`;

export const ValidationCodeContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  width: 50%;
  margin-top: 40px;
  @media (max-width: 1024px) {
    width: 100%;
    padding-right: 20px;
  }
`;
export const TimeContainer = styled.div`
  color: #5276a3;
  margin-left: 10px;
  font-size: 14px;
  @media (max-width: 1024px) {
    margin-left: 7px;
  }
`;
export const RepeatCodeBtn = styled.div`
  color: #bccadb;
  cursor: pointer;
  font-weight: 400;
  font-weight: 12px;
  @media (max-width: 1024px) {
    font-size: 12px;
  }
`;
export const Text = styled.span`
  text-align: right;
  direction: rtl;
  color: var(--text-500);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 40px;
  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 5%;
`;

export const NumberContainer = styled.input`
  width: 65px;
  height: 65px;
  background-color: #e9ebf8;
  border-radius: 12px;
  border: 2px solid #629ee8;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  margin-left: 10px;
  &:active {
    border: 2px solid #629ee8;
  }
  &:focus {
    border: 2px solid #629ee8;
  }
`;
